import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Calender = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4C9 3.44772 9.44772 3 10 3C10.5523 3 11 3.44772 11 4V5H21V4C21 3.44772 21.4477 3 22 3C22.5523 3 23 3.44772 23 4V5H28C29.1046 5 30 5.89543 30 7V27C30 28.1046 29.1046 29 28 29H4C2.89543 29 2 28.1046 2 27V7C2 5.89543 2.89543 5 4 5H9V4ZM21 7V8C21 8.55228 21.4477 9 22 9C22.5523 9 23 8.55228 23 8V7H28V11H4V7H9V8C9 8.55228 9.44772 9 10 9C10.5523 9 11 8.55228 11 8V7H21ZM4 13V27H28V13H4Z"
        fill={color}
      />
    </svg>
  );
};

export default Calender;
